import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";

export default function ProtectedRoute({ children }) {
  const { session, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center gap-4 bg-ink">
        <div className="font-display text-xs text-cyan sm:text-sm">LOADING CARTRIDGE</div>
        <div className="h-3 w-56 border-2 border-black bg-panel">
          <div className="h-full w-1/2 animate-pulse bg-cyan" />
        </div>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
